import React from "react";
import {
  CContainer,
  CCard,
  CCardBody,
  CCardTitle,
  CCardText,
  CButton,
  CRow,
  CCol,
} from "@coreui/react";
import { CIcon } from "@coreui/icons-react";
import { cilWarning } from "@coreui/icons"; // CoreUI Free Icons

const ErrorPage = ({ message }) => (
  <CContainer
    fluid
    className="d-flex flex-column justify-content-center align-items-center"
    style={{ minHeight: "90vh" }}
  >
    <CRow className="justify-content-center w-100">
      <CCol xs={12} sm={10} md={8} lg={6}>
        <CCard
          className="shadow-lg border-0 text-center p-4 py-5"
          style={{ backgroundColor: "#f8d7da" }}
        >
          <div className="mb-3 d-flex flex-column align-items-center">
            <CIcon icon={cilWarning} size="3xl" className="text-danger mb-2" />
            <CCardTitle
              className="mb-2"
              style={{ fontSize: "2rem", fontWeight: 700 }}
            >
              Oops! Algo correu mal
            </CCardTitle>
          </div>
          <CCardText>
            Não foi possível obter os dados necessários para mostrar esta
            página.
            <br />
            <span className="text-muted fw-bold">
              {message ||
                "Erro desconhecido. Por favor, tenta novamente mais tarde."}
            </span>
          </CCardText>
          <CCardText className="mt-3">
            <ul
              style={{
                textAlign: "left",
                margin: "0 auto",
                maxWidth: 350,
                fontSize: "0.98rem",
              }}
            >
              <li>Verifica a tua ligação à Internet.</li>
              <li>Se o problema persistir, tenta recarregar a página.</li>
              <li>Contacta o suporte se o erro se mantiver.</li>
            </ul>
          </CCardText>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
);

export default ErrorPage;
